import {
  Module,
  VuexModule,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";
import { HyDryDeviceSettings } from "@/data/models/Settings";
import { createDefaultHyDryDeviceSettings } from "@/data/models/Client";
import { ComBoxHumidityUnit } from "@/data/models/ComBoxHumidityUnit";

const name = "hyDryDeviceSettings";

@Module({ dynamic: true, namespaced: true, store, name: name })
export class HyDryDeviceSettingsVuexModule extends VuexModule {
  hyDryDeviceSettings: HyDryDeviceSettings = createDefaultHyDryDeviceSettings();

  @Mutation
  setHyDryDeviceSettings(hyDryDeviceSettings: HyDryDeviceSettings) {
    this.hyDryDeviceSettings = hyDryDeviceSettings;
  }

  @Mutation
  setComBoxHumidityUnit(comBoxHumidityUnit: ComBoxHumidityUnit) {
    if (this.hyDryDeviceSettings.comBoxClientConfigInfo?.humidityUnit) {
      this.hyDryDeviceSettings.comBoxClientConfigInfo.humidityUnit = comBoxHumidityUnit;
    }
  }

  @Mutation
  clear() {
    this.hyDryDeviceSettings = createDefaultHyDryDeviceSettings();
  }
}

export const HyDryDeviceSettingsModule = getModule(HyDryDeviceSettingsVuexModule, store);
